import { render } from "./MenuPanelConfigPanel.vue?vue&type=template&id=23817aa7&scoped=true"
import script from "./MenuPanelConfigPanel.vue?vue&type=script&lang=js"
export * from "./MenuPanelConfigPanel.vue?vue&type=script&lang=js"

import "./MenuPanelConfigPanel.vue?vue&type=style&index=0&id=23817aa7&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23817aa7"]])

export default __exports__